import React from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import moment from 'moment';

const View = ({ show, onClose, trialbalanceData }) => {

        // console.log('trail--------->',trialbalanceData);
        const trial = trialbalanceData;


    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">View Trial Balance</h3>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Created Date</label>
                            <label className='text-black fs-6 font-w500'>{moment(trial.created_at).format('DD-MMM-YYYY')}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Ledger</label>
                            <label className='text-black fs-6 font-w500'>{trial.ledger_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Sub Ledger</label>
                            <label className='text-black fs-6 font-w500 text-break'>{trial.subledger_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Ledger Account</label>
                            <label className='text-black fs-6 font-w500'>{trial.ledger_account_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Mode</label>
                            <label className='text-black fs-6 font-w500'>{trial.is_credit?('credit'):('debit')}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Amount</label>
                            <label className='text-danger font-w500 fs-6 py-0 px-1'>
                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                <span>{trial.amount}</span>
                            </label>
                        </div>
                        <div class="row mb-2">
                            <label class="col-12 text-gray-800 font-w500 fs-7">Description </label>
                            <label class="col-12 text-black fs-6 font-w500 ms-3 mt-1 px-2 py-1">&emsp;&emsp; {trial.description}

                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default View;
